<template>
  <div class="position-relative">
    <input v-model="search"
           @keyup.enter="select_item(items[active_index])"
           @keyup.up="active_index>0? active_index-- : null"
           @keyup.down="active_index<items.length ? active_index++ : null"
           :placeholder="placeholder" style="height:32px;border:1px solid grey;border-radius: 3px;width: 100%"/>
    <div v-show="items.length>0"
         class="list-container"
         style="position: absolute;border-bottom:1px solid gray;top: 32px;width: 100%;z-index: 100000;background: #e3e3e3;max-height: 150px;height: fit-content;min-height: 40px;overflow: auto">
      <div :key="'autocomplete'+index_row"
           v-for="(item,index_row) in items"
           @click="select_item(item)"
           tabindex="0"
           :class="`${active_index==index_row?'active':''} custom-autocomplete-row`"
           style="cursor: pointer;padding: 2px">
        {{ item.productCodeName }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'AutocompleteSearchProduct',
  slots: [],

  components: {},

  data() {
    return {
      search: '',
      items: [],
      placeholder: this.$t('components.searchProduct'),
      active_index: -1,
      timeout: null,
    }
  },
  computed: {},
  watch: {
    'search': function () {
      var self = this
      if (this.timeout != null) {
        clearTimeout(this.timeout)
      }
      self.timeout = setTimeout(function () {
        self.load_products()
      }, 300)
    },
    active_index(newIndex) {
      this.$nextTick(() => {
        if (this.active_index != -1) {
          const activeItem = document.querySelector('.custom-autocomplete-row.active');
          activeItem.scrollIntoView({behavior: 'smooth', block: 'nearest'});
          // document.getElementsByClassName('list-container')[0].scrollIntoView(activeItem)
        }

      });
    }
  },
  mounted() {
    axios.defaults.baseURL = localStorage.getItem("api_address");
  },
  methods: {
    select_item(item) {

      this.$emit('input', item.id)
      this.$emit('select', item);
      this.placeholder = item.productCodeName
      this.items = []
      this.search = ""
    },
    load_products() {
      var self = this
      if (this.search.length <= 2) {
        this.items = []
        return
      }
      const formData = new FormData();

      formData.append('SearchTxt', this.search);
      if (this.document_person != null) {
        formData.append('PersonId', this.document_person);
      }

      axios.post('GetProducts', formData, {show_pros: true})
          .then(function (response) {
            if (self.search == formData.get("SearchTxt")) {
              self.items = response.data.data
              self.active_index = -1
            }
          })
          .catch(function (error) {
            console.log(error);
          });

    },
  },


}
</script>
<style>
.list-container {
  scroll-behavior: smooth; /* اسکرول نرم */
}

.custom-autocomplete-row {
  scroll-behavior: smooth;
}

.custom-autocomplete-row.active {
  background: #007bff; /* رنگ آیتم فعال */
  color: white;
  outline: none;
}
</style>